import { IFRAME_POSTMESSAGE_TYPE, WEBVIEW_MESSAGE_TYPE } from "../enums";
import { WebViewEvent } from "../types/interface.types";
import { Product } from "../types/model.types";

class BrowserEventService {
  onProductClick = (product: string) => {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.NAVIGATE_PDP_PAGE,
      message: { product },
    });
  };
  onAddToBasketClick = (product: Product, quantity: number) => {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.ADD_TO_BASKET,
      message: { product, quantity },
    });
  };
  onSeeAllClick = () => {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.SEE_ALL,
    });
  };
  onCloseClick = () => {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.CLOSE,
    });
  };
  sendHeight = (height: number) => {
    this.postMessage({
      type: IFRAME_POSTMESSAGE_TYPE.SET_HEIGHT,
      message: { height },
    });
  };

  triggerRedirectToLogin = () => {
    this.postMessage({
      type: WEBVIEW_MESSAGE_TYPE.REDIRECT_TO_LOGIN,
    });
  };

  private postMessage(eventData: WebViewEvent) {
    console.info("BrowserEventService: Posting message to parent window");
    window.parent.postMessage(eventData, "*");
    console.info("BrowserEventService: Message posted successfully", eventData);
  }
}

const SendBrowserEvent = new BrowserEventService();

export default SendBrowserEvent;
